import { WHATSAPP_URL } from "../data/content";

export const WhatsAppIcon = ({ className = "h-5 w-5" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.39-1.48-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.61-.91-2.21-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35M12.05 21.8h-.01a9.8 9.8 0 0 1-4.99-1.37l-.36-.21-3.71.97.99-3.62-.23-.37a9.78 9.78 0 0 1-1.5-5.22c0-5.41 4.4-9.81 9.82-9.81 2.62 0 5.08 1.02 6.93 2.88a9.75 9.75 0 0 1 2.87 6.94c0 5.41-4.4 9.81-9.81 9.81m8.35-18.16A11.76 11.76 0 0 0 12.05 0C5.52 0 .21 5.31.21 11.84c0 2.09.55 4.13 1.58 5.92L.1 24l6.38-1.67a11.8 11.8 0 0 0 5.57 1.42h.01c6.52 0 11.84-5.31 11.84-11.84 0-3.16-1.23-6.14-3.47-8.37" />
  </svg>
);

export const WhatsAppButton = ({ className = "", children, testId }) => (
  <a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    className={`inline-flex items-center gap-2 ${className}`}
    data-testid={testId}
  >
    <WhatsAppIcon className="h-5 w-5 shrink-0" />
    {children}
  </a>
);

export const WhatsAppFloat = () => (
  <a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with Ulyana on WhatsApp"
    className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(0,0,0,.22)] transition-transform duration-300 hover:-translate-y-1 hover:scale-105 sm:bottom-7 sm:right-7"
    data-testid="whatsapp-float-button"
  >
    <WhatsAppIcon className="h-7 w-7" />
  </a>
);
